import { render } from "./SupermarketTranscription.vue?vue&type=template&id=11f160a6&scoped=true"
import script from "./SupermarketTranscription.vue?vue&type=script&lang=js"
export * from "./SupermarketTranscription.vue?vue&type=script&lang=js"

import "./SupermarketTranscription.vue?vue&type=style&index=0&id=11f160a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f160a6"]])

export default __exports__